/*
 * MSCVTR — gedrag van de productpagina (Horizon-migratie, pakket 9, 20-10-2026). Nieuw geschreven.
 *  - variantkeuze: radioknoppen → juiste variant-id in het formulier, URL (?variant=), prijs/voorraad/koopknop
 *    opnieuw ophalen via de Section Rendering API, galerij per kleur; stuurt 'variant:change' (detail.variant)
 *  - toevoegen: submit van het productformulier → /cart/add.js → eigen winkelwagen-lade opent.
 *    De maatkiezer (pakken) houdt een submit zonder maat al in de capture-fase tegen; dan komt het hier niet.
 *  - "recent bekeken" bijhouden (localStorage 'theme:recently-viewed-products', zelfde sleutel als het oude thema)
 *  - galerij: vergroting, #maatkeuze → naar de maatkiezer scrollen
 */
(() => {
  if (window.MSCVTR_PDP) return;
  window.MSCVTR_PDP = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const leesJson = (pdp) => {
    try { return JSON.parse(pdp.querySelector('[data-mscvtr-product-json]').textContent); } catch (e) { return null; }
  };

  /* ── Variantkeuze ──────────────────────────────────────────────────────────── */
  const gekozenOpties = (pdp) => {
    const opties = [];
    pdp.querySelectorAll('.mscvtr-optie').forEach((veld) => {
      const pos = Number(veld.dataset.optiePositie);
      const input = veld.querySelector('input[type=radio]:checked');
      if (input) opties[pos - 1] = input.dataset.naam;
    });
    return opties;
  };

  let ophaal = null;
  const toonVoorraad = (pdp, variant) => {
    const regel = pdp.querySelector('[data-block-type="inventory"] .mscvtr-voorraad');
    if (!regel) return; // Maatpakken hebben geen voorraadmelding.
    const beschikbaar = !!variant?.available;
    regel.classList.toggle('mscvtr-voorraad--urgentie', beschikbaar);
    regel.classList.toggle('mscvtr-voorraad--uit', !beschikbaar);
    const tekst = regel.querySelector('[data-mscvtr-stock-message]');
    if (tekst) tekst.textContent = beschikbaar ? `${variant.display_quantity} stuks beschikbaar` : 'Niet op voorraad';
    const knop = pdp.querySelector('[data-mscvtr-koopknop]');
    if (knop) knop.disabled = !beschikbaar;
  };
  const verversBlokken = async (pdp, variantId) => {
    ophaal?.abort();
    ophaal = new AbortController();
    const url = `${pdp.dataset.url}?variant=${variantId}&section_id=${pdp.dataset.sectie}`;
    const res = await fetch(url, { signal: ophaal.signal });
    if (!res.ok) return;
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const stickyNieuw = doc.querySelector('[data-mscvtr-sticky]');
    const stickyOud = document.querySelector('[data-mscvtr-sticky]');
    if (stickyNieuw && stickyOud) stickyOud.innerHTML = stickyNieuw.innerHTML;
    ['price', 'inventory', 'buy-buttons'].forEach((type) => {
      const nieuw = doc.querySelector(`.mscvtr-pdp__blok[data-block-type="${type}"]`);
      const oud = pdp.querySelector(`.mscvtr-pdp__blok[data-block-type="${type}"]`);
      if (nieuw && oud) oud.innerHTML = nieuw.innerHTML;
    });
    // Beschikbaarheid per waarde (doorgestreept) bijwerken.
    doc.querySelectorAll('.mscvtr-optie label').forEach((label) => {
      const hier = pdp.querySelector(`label[for="${CSS.escape(label.getAttribute('for'))}"]`);
      if (hier) hier.classList.toggle('is-disabled', label.classList.contains('is-disabled'));
    });
  };

  const galerijNaarKleur = (pdp, opties, json, variant) => {
    const items = pdp.querySelectorAll('.mscvtr-galerij__item[data-groep]');
    if (!items.length) {
      // Feedback Pascal 02-11: kies je een kleur, dan komt de foto van die kleur vooraan (variantfoto uit Shopify).
      const spoor = pdp.querySelector('.mscvtr-galerij__spoor');
      const id = variant && variant.featured_media_id;
      const item = id && spoor && spoor.querySelector(`.mscvtr-galerij__item[data-media-id="${id}"]`);
      if (item && spoor.firstElementChild !== item) {
        const labels = spoor.querySelector('.mscvtr-galerij__labels');
        spoor.prepend(item);
        if (labels) item.prepend(labels);
      }
      if (spoor) spoor.scrollLeft = 0;
      return;
    }
    const namen = [...pdp.querySelectorAll('.mscvtr-optie')].map((v) => (v.querySelector('legend')?.textContent || '').replace(':', '').trim().toLowerCase());
    items.forEach((item) => {
      const i = namen.indexOf(item.dataset.groep);
      if (i < 0) return;
      item.hidden = (opties[i] || '').toLowerCase() !== item.dataset.waarde;
    });
    const spoor = pdp.querySelector('.mscvtr-galerij__spoor');
    if (spoor) spoor.scrollLeft = 0;
  };

  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!input.matches('.mscvtr-optie input[type=radio]')) return;
    const pdp = input.closest('[data-mscvtr-pdp]');
    const json = pdp && leesJson(pdp);
    if (!json) return;
    const veld = input.closest('.mscvtr-optie');
    const gekozen = veld.querySelector('[data-mscvtr-gekozen]');
    if (gekozen) gekozen.textContent = input.dataset.naam;

    const opties = gekozenOpties(pdp);
    const variant = json.variants.find((v) => v.options.every((o, i) => o === opties[i]));
    toonVoorraad(pdp, variant);
    const idVeld = document.querySelector(`#${CSS.escape(pdp.dataset.form)} [data-mscvtr-variant-id]`);
    if (variant && idVeld) idVeld.value = variant.id;
    if (variant) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      verversBlokken(pdp, variant.id).catch(() => {});
    } else {
      const knop = pdp.querySelector('[data-mscvtr-koopknop]');
      if (knop) { knop.disabled = true; knop.textContent = 'Niet beschikbaar'; }
    }
    galerijNaarKleur(pdp, opties, json, variant);
    pdp.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant || null, bron: 'mscvtr-pdp' } }));
  });

  /* ── Toevoegen aan winkelwagen ─────────────────────────────────────────────── */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('[data-mscvtr-form]')) return;
    e.preventDefault();
    const formId = form.getAttribute('id'); // niet form.id: het veld name="id" overschaduwt die eigenschap
    const pdp = document.querySelector(`[data-mscvtr-pdp][data-form="${CSS.escape(formId)}"]`);
    const knop = pdp?.querySelector('[data-mscvtr-koopknop]') || document.querySelector(`button[type=submit][form="${CSS.escape(formId)}"]`);
    const fout = pdp?.querySelector('[data-mscvtr-koopfout]');
    if (fout) fout.hidden = true;
    // Tweede slot: een pak (maatkiezer op de pagina) gaat nooit zonder colbertmaat de winkelwagen in,
    // ook niet als de maatkiezer zelf (capture-fase) om wat voor reden dan ook niet heeft ingegrepen.
    const data = new FormData(form);
    if (pdp?.querySelector('[data-mscvtr-maat]') && !data.get('properties[Colbertmaat]')) {
      const hulp = pdp.querySelector('[data-mscvtr-maat-hulp]');
      if (hulp) { hulp.textContent = 'Kies eerst een maat.'; hulp.classList.add('is-fout'); }
      pdp.querySelector('[data-mscvtr-maat]').scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    knop?.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${root()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.description || json.message || 'Toevoegen is niet gelukt.');
      if (window.MSCVTR && MSCVTR.verversWinkelwagen) await MSCVTR.verversWinkelwagen({ open: true });
      else location.href = `${root()}cart`;
    } catch (err) {
      if (fout) { fout.textContent = err.message; fout.hidden = false; }
    } finally {
      knop?.removeAttribute('aria-busy');
    }
  });

  /* ── Recent bekeken ─────────────────────────────────────────────────────────── */
  const KEY = 'theme:recently-viewed-products';
  const bewaarRecent = () => {
    const pdp = document.querySelector('[data-mscvtr-pdp]');
    if (!pdp) return;
    const id = Number(pdp.dataset.productId);
    try {
      let lijst = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(lijst)) lijst = [];
      lijst = [id, ...lijst.filter((x) => Number(x) !== id)].slice(0, 20);
      localStorage.setItem(KEY, JSON.stringify(lijst));
    } catch (e) {}
  };

  /* ── Galerij: vergroting met PhotoSwipe 5 (MIT, officiële release; assets/mscvtr-photoswipe.*) ─────── */
  let pswpModule = null;
  const laadPhotoSwipe = async (galerij) => {
    if (!document.querySelector('link[data-mscvtr-pswp]')) {
      const l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = galerij.dataset.pswpCss; l.dataset.mscvtrPswp = '';
      document.head.appendChild(l);
    }
    if (!pswpModule) pswpModule = await import(galerij.dataset.pswpJs);
    return pswpModule.default;
  };
  const eenvoudig = (galerij, items, index) => {
    const dialog = galerij.querySelector('[data-mscvtr-groot]');
    if (!dialog) return;
    const lijst = dialog.querySelector('[data-mscvtr-groot-lijst]');
    lijst.innerHTML = '';
    items.forEach((item) => {
      const img = document.createElement('img');
      img.src = item.dataset.groot; img.alt = item.querySelector('img')?.alt || ''; img.loading = 'lazy';
      lijst.appendChild(img);
    });
    dialog.showModal();
    requestAnimationFrame(() => lijst.children[Math.max(0, index)]?.scrollIntoView({ block: 'start' }));
  };
  document.addEventListener('click', async (e) => {
    const zoom = e.target.closest('[data-mscvtr-zoom]');
    if (zoom) {
      const galerij = zoom.closest('[data-mscvtr-galerij]');
      if (!galerij) return;
      const items = [...galerij.querySelectorAll('.mscvtr-galerij__item:not([hidden])')].filter((i) => i.dataset.groot);
      let index = items.indexOf(zoom.closest('.mscvtr-galerij__item'));
      if (index < 0) {
        // Zoomknop (mobiel): de foto die nu in de schuifrij staat.
        const spoor = galerij.querySelector('.mscvtr-galerij__spoor');
        index = spoor && spoor.clientWidth ? Math.round(spoor.scrollLeft / spoor.clientWidth) : 0;
      }
      try {
        const PhotoSwipe = await laadPhotoSwipe(galerij);
        const pswp = new PhotoSwipe({
          dataSource: items.map((i) => ({ src: i.dataset.groot, width: Number(i.dataset.breedte) || 1600, height: Number(i.dataset.hoogte) || 2400, alt: i.querySelector('img')?.alt || '' })),
          index: Math.max(0, index),
          bgOpacity: 1,
          showHideAnimationType: 'fade',
          errorMsg: 'De foto kon niet worden geladen',
          // Eigen bediening zoals de referentie: drie witte ronde knoppen onderaan (vorige, sluiten, volgende).
          arrowPrev: false, arrowNext: false, close: false, zoom: false, counter: false,
        });
        pswp.on('uiRegister', () => {
          pswp.ui.registerElement({
            name: 'mscvtr-knoppen',
            appendTo: 'root',
            html: '<button type="button" class="mscvtr-pswp__knop" data-actie="prev" aria-label="Vorige"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 2 4 8l6 6" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></button>' +
                  '<button type="button" class="mscvtr-pswp__knop" data-actie="close" aria-label="Sluiten"><svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
                  '<button type="button" class="mscvtr-pswp__knop" data-actie="next" aria-label="Volgende"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m6 2 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></button>',
            onInit: (el, ps) => {
              el.classList.add('mscvtr-pswp__balk');
              el.addEventListener('click', (ev) => {
                const k = ev.target.closest('[data-actie]');
                if (k) ps[k.dataset.actie]();
              });
            },
          });
        });
        pswp.init();
      } catch (err) {
        eenvoudig(galerij, items, index);
      }
      return;
    }
    const sluit = e.target.closest('[data-mscvtr-groot-sluit]');
    if (sluit) sluit.closest('dialog')?.close();
  });

  /* ── Vanaf een productkaart (#maatkeuze): naar de maatkiezer scrollen ─────────── */
  const naarMaat = () => {
    if (location.hash !== '#maatkeuze') return;
    const doel = document.querySelector('.mscvtr-maat') ||
      [...document.querySelectorAll('.mscvtr-optie')].find((f) => /maat|size/i.test(f.querySelector('legend')?.textContent || ''));
    if (doel) doel.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  /* ── Vaste winkelwagenbalk: zichtbaar zodra de koopknop boven uit beeld is ─────────────── */
  const startSticky = () => {
    const pdp = document.querySelector('[data-mscvtr-pdp]');
    const balk = pdp?.querySelector('[data-mscvtr-sticky]');
    const knop = pdp?.querySelector('.mscvtr-pdp__blok[data-block-type="buy-buttons"]');
    if (!balk || !knop || !('IntersectionObserver' in window)) return;
    // De balk onder <body> hangen: anders valt hij binnen de scrollcontainer/stapelcontext van de pagina.
    document.body.appendChild(balk);
    new IntersectionObserver(([entry]) => {
      const boven = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      balk.classList.toggle('is-zichtbaar', boven);
      balk.setAttribute('aria-hidden', boven ? 'false' : 'true');
      balk.querySelector('button')?.setAttribute('tabindex', boven ? '0' : '-1');
    }).observe(knop);
  };

  const start = () => { bewaarRecent(); startSticky(); setTimeout(naarMaat, 150); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
